import {
	CatDoseMapSvg,
	CategoriesSvg,
	CSVSvg,
	DashboardSvg,
	DoseFormSvg,
	GroceriesSidebarIcon,
	QualityCheckSvg,
	RejectSvg,
	RoleSvg,
	SubCategoriesSvg,
	UsersSvg,
	WarningSvg,
} from 'utils/svgs';

type MenuIconComponent = (props: { isSelected?: boolean }) => JSX.Element;

/** Shared sidebar icons — grocery category/sub-category keys reuse medicine panel SVGs. */
const MENU_ICON_COMPONENTS: Record<string, MenuIconComponent> = {
	users: UsersSvg,
	roles: RoleSvg,
	staff: UsersSvg,
	'import-data': CSVSvg,
	dashboard: DashboardSvg,
	medicines: GroceriesSidebarIcon,
	groceries: GroceriesSidebarIcon,
	'grocery-quality-check': QualityCheckSvg,
	'grocery-rejected': RejectSvg,
	'grocery-categories': CategoriesSvg,
	'grocery-sub-categories': SubCategoriesSvg,
	'draft-medicines-request': GroceriesSidebarIcon,
	rejected: RejectSvg,
	categories: CategoriesSvg,
	'sub-categories': SubCategoriesSvg,
	'quality-check': QualityCheckSvg,
	'warning-tags': WarningSvg,
	'dose-form': DoseFormSvg,
	'category-dose-form-mapping': CatDoseMapSvg,
};

export const getSidebarMenuIcon = (
	key: string,
	isSelected = false,
): JSX.Element | null => {
	const Icon = MENU_ICON_COMPONENTS[key];
	if (!Icon) return null;
	return <Icon isSelected={isSelected} />;
};
